import React, { useMemo } from 'react';
import { appRoutes, buildAutomationEditPath, buildSegmentEditPath } from '../../app-routes';
import {
  FeatureSurfaceContext,
  type FeatureSurface,
  type FeatureSurfaceName,
} from './FeatureSurfaceContext';

type FeatureSurfaceRoutes = Pick<
  FeatureSurface,
  'basePath' | 'automationsPath' | 'segmentsPath' | 'newSegmentPath'
>;

/** Paths come from `appRoutes` rather than being recomputed here, so there is one definition. */
const ROUTES_BY_FEATURE: Record<FeatureSurfaceName, FeatureSurfaceRoutes> = {
  engage: {
    basePath: appRoutes.ENGAGE_SETUP,
    automationsPath: appRoutes.ENGAGE_AUTOMATIONS,
    segmentsPath: appRoutes.ENGAGE_SEGMENTS,
    newSegmentPath: appRoutes.ENGAGE_SEGMENTS_NEW,
  },
  reputation: {
    basePath: appRoutes.REPUTATION_SETUP,
    automationsPath: appRoutes.REPUTATION_AUTOMATIONS,
    segmentsPath: appRoutes.REPUTATION_SEGMENTS,
    newSegmentPath: appRoutes.REPUTATION_SEGMENTS_NEW,
  },
};

type FeatureSurfaceProviderProps = React.PropsWithChildren<{
  feature: FeatureSurfaceName;
}>;

export const FeatureSurfaceProvider: React.FC<FeatureSurfaceProviderProps> = ({ feature, children }) => {
  const surface = useMemo<FeatureSurface>(() => {
    const routes = ROUTES_BY_FEATURE[feature];
    return {
      feature,
      ...routes,
      buildAutomationEditPath: buildAutomationEditPath.bind(null, routes.basePath),
      buildSegmentEditPath: buildSegmentEditPath.bind(null, routes.basePath),
    };
  }, [feature]);

  return <FeatureSurfaceContext.Provider value={surface}>{children}</FeatureSurfaceContext.Provider>;
};
